import React from "react";
import { Field } from "react-final-form";
import FpInput from "./FpInput/FpInput";
import styles from "./style.module.scss";

class Input extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Field {...this.props}>
        {({ input, meta }) => (
          <div className={this.props.className}>
            <FpInput
              type={this.props.type}
              onWheel={(e) => e.target.blur()}
              placeholder={this.props.placeholder}
              defaultValue={input.value}
              onChange={input.onChange}
              name={input.name}
              className={
                meta.error && meta.touched && styles.validator_error_style
              }
            />
            {meta.error && meta.touched && (
              <p className={styles.validator_text}>{meta.error}</p>
            )}
          </div>
        )}
      </Field>
    );
  }
}

export default Input;
